const HashScroll = {
    init() {
        if (!this.getTarget()) return;

        this.scrollToHash();

        window.addEventListener('load', () => this.scrollToHash());

        if (document.fonts?.ready) {
            document.fonts.ready.then(() => this.scrollToHash());
        }
    },

    getTarget() {
        const id = decodeURIComponent(window.location.hash.replace(/^#/, ''));
        if (!id) return null;
        return document.getElementById(id);
    },

    scrollToHash() {
        const target = this.getTarget();
        if (!target) return;

        const html = document.documentElement;
        const previous = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
        html.style.scrollBehavior = previous;
    },
};

export default HashScroll;
